import { Column } from 'react-table';

import { IOverallPdfUsageTableData } from './OverallPdfTableView.interfaces';

const OVERALL_PDF_TABLE_COLUMNS: ReadonlyArray<Column<IOverallPdfUsageTableData>> = [
  {
    accessor: 'date',
    Cell: ({ value }) => <div>{value}</div>,
    Header: () => <div>Date</div>,
  },
    {
    accessor: 'apiKey',
    Cell: ({ value }) => <div>{value}</div>,
    Header: () => <div>API key</div>,
  },
  {
    accessor: 'count',
    Cell: ({ value }) => <div>{value}</div>,
    Header: () => <div>Total PDFs generated</div>,
  },
];


export { OVERALL_PDF_TABLE_COLUMNS };
